import React, { useEffect, useState, useRef } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import ToggleButton from 'react-bootstrap/ToggleButton';
import './PrintReportPage.scss';
import { useLocation } from 'react-router-dom';
import { requireAuth } from '../../util/auth';
import CustomTable from '../Table/CustomTable';
import { format1090ReportParameter } from '../../util/tenNinety';

function PrintReportPage() {
  const location = useLocation();
  const { currentModalReport, tenNinetyData, tenNinetyColumns } = location.state || {};
  const pageSizeDefault = 20;

  const originalColumnsRef = useRef(null);
  const [newColumns, setNewColumns] = useState(tenNinetyColumns || []);
  const [openPrint, setOpenPrint] = useState(false);

  useEffect(() => {
    if (!tenNinetyColumns) return;

    originalColumnsRef.current = tenNinetyColumns;

    const newColumns = tenNinetyColumns.map((col) => ({
      ...col,
      flex: undefined,
      width: 400,
      maxWidth: 400
    }));

    setNewColumns(newColumns);
    setOpenPrint(true);

    setTimeout(() => {
      window.print();
    }, 500);
  }, [tenNinetyColumns]);

  useEffect(() => {
    const handleBeforePrint = () => {
      setTimeout(() => {
        setOpenPrint(false);
        setNewColumns(originalColumnsRef.current);
      }, 0);
    };

    window.addEventListener('beforeprint', handleBeforePrint);

    return () => {
      window.removeEventListener('beforeprint', handleBeforePrint);
    };
  }, []);

  return (
    <>
      <Row>
        <Col className="text-end">
          <h3>40CFR1090 Precision Report</h3>
        </Col>
      </Row>
      <Row className="report-header">
        <h4>EPA Compliance Report for Precision of Alternative Procedure: 40 CFR 1090.1365</h4>
      </Row>
      <Row>
        <Col>Method:</Col>
        <Col>{currentModalReport.method}</Col>
        <Col>Location:</Col>
        <Col>{currentModalReport.location}</Col>
      </Row>
      <Row>
        <Col>Instrument:</Col>
        <Col>{currentModalReport.instrument}</Col>
        <Col>Date:</Col>
        <Col>{currentModalReport.completedOn}</Col>
      </Row>
      <Row>
        <Col>Fuel, additive or blendstock:</Col>
        <Col>{currentModalReport.fab}</Col>
        <Col>Assessment by:</Col>
        <Col>{currentModalReport.completedBy}</Col>
      </Row>
      <Row>
        <Col>Parameter:</Col>
        <Col>{format1090ReportParameter(currentModalReport)}</Col>
        <Col>Pre-treated:</Col>
        <Col>{currentModalReport.pretreated}</Col>
      </Row>
      <Row className="report-header" />
      <Row className="statistics-table">
        <div style={{ width: openPrint ? 800 : '80%' }}>
          <CustomTable
            numberOfRows={pageSizeDefault}
            data={tenNinetyData}
            header={openPrint ? newColumns : tenNinetyColumns}
            hideFooter={true}
          />
        </div>
      </Row>
      <Row style={{ display: 'flex', justifyContent: 'center', marginBottom: '4px' }}>
        <Col lg={7}>
          <h6>6. Assessor comments</h6>
        </Col>
      </Row>
      <Row style={{ display: 'flex', justifyContent: 'center', marginBottom: '4px' }}>
        <Col lg={8}>
          <Form>
            <Form.Group>
              <Form.Control
                className="comments"
                as="textarea"
                rows={2}
                aria-label="Basic example"
                value={currentModalReport.comments}
              />
            </Form.Group>
          </Form>
        </Col>
      </Row>
      <Row style={{ display: 'flex', justifyContent: 'center', marginBottom: '4px' }}>
        <Col lg={7}>
          <h6>7. Assessment outcome</h6>
        </Col>
      </Row>
      <Row>
        <Col style={{ display: 'flex', justifyContent: 'center', gap: '4px' }}>
          <ToggleButton
            key="radioTrending-pass"
            id="radioTrending-pass"
            type="radio"
            variant="outline-primary"
            name="radio"
            value="Pass"
            style={
              currentModalReport.outcome === 'Pass'
                ? { backgroundColor: 'navy', color: 'white' }
                : {}
            }
            checked={currentModalReport.outcome === 'Pass'}
          >
            Pass
          </ToggleButton>
          <ToggleButton
            key="radioTrending-fail"
            id="radioTrending-fail"
            type="radio"
            variant="outline-primary"
            name="radio"
            value="Fail"
            style={
              currentModalReport.outcome === 'Fail'
                ? { backgroundColor: 'navy', color: 'white' }
                : {}
            }
            checked={currentModalReport.outcome === 'Fail'}
          >
            Fail
          </ToggleButton>
        </Col>
      </Row>
    </>
  );
}

export default requireAuth(PrintReportPage);
